import StyledLink from '../StyledLink'
import {
  DESIGNER,
  EDITOR,
  MODEL_HUB
} from '../routes'
import type { Props } from '../types'

interface Params {
  modeluuid: string
  isRenderIcon?: boolean
}

const LinkToModelEdit = ({
  children,
  label,
  modeluuid,
  isHyperlink,
  openInNewTab,
  isRenderIcon = false
}: (Props & Params)) =>
  <StyledLink
    aria-label={label}
    isHyperlink={isHyperlink}
    isRenderIcon={isRenderIcon}
    openInNewTab={openInNewTab}
    to={`/${DESIGNER}/${MODEL_HUB}/${modeluuid}/${EDITOR}`}
  >
    {children}
  </StyledLink>

export default LinkToModelEdit
